import { EventEmitter, Inject, Injectable, OnInit, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { TableService } from '../services/table.service';
import { LOCAL_STORAGE, WebStorageService } from 'ngx-webstorage-service';
import * as moment from 'moment';
import { LoaderService } from '../loader/loader.service';
declare var $: any;

export interface Baixa {
  cnpj: String;
  cpf_cobrador: string;
  mensagem_contrato: string;
  forma_pagamento: string;
  quantidade_parcelas: string;
  baixas: ArrayBaixas;
}
export interface ArrayBaixas extends Array<Baixas> {}
export interface Baixas {
  id: string;
  cliente: string;
  contrato: string;
  chave: string;
  data_baixa: string;
  valor_titulo: string;
  nsu: string;
  bandeira: string;
  aut: string;
  gateway: string;
  valor_juros: string;
  valor_multa: string;
  valor_desconto: string;
}

@Injectable({
  providedIn: 'root',
})
export class CobrancasService implements OnInit {
  @Output() titulosup: EventEmitter<any> = new EventEmitter();
  @Output() titulosdown: EventEmitter<any> = new EventEmitter();
  @Output() filterout: EventEmitter<any> = new EventEmitter();

  constructor(
    private http: HttpClient,
    private load: LoaderService,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private table: TableService
  ) {}

  base;

  titulos = [];
  titulosvinc = [];

  async ngOnInit() {}

  settitulosvinc() {
    return this.titulosup;
  }

  settitulosdesvinc() {
    return this.titulosdown;
  }

  vinculatitulos(i: number, t: any) {
    this.titulosup.emit([i, t]);
  }

  desvinculatitulos(i, t) {
    this.titulosdown.emit([i, t]);
  }

  filter(e) {
    this.filterout.emit(e);
  }

  setfilter() {
    return this.filterout;
  }

  async getPagamentos() {
    if (!environment.selected.cnpj) {
      return [];
    }
    const rangeDate = $('.dash-daterange').val().split('-');
    const dataIni = moment(rangeDate[0], 'DD/MM/YYYY').format('YYYY-MM-DD');
    const dataFim = moment(rangeDate[1], 'DD/MM/YYYY').add(1, 'day').format('YYYY-MM-DD');
    return new Promise(async resolve => {
      this.http
        .post(`${environment.cobranca}/find/${environment.selected.cnpj}/pagamentos`, {
          query: [
            {
              $match: {
                cnpj: environment.selected.cnpj,
                createdAt: {
                  $gt: dataIni,
                  $lt: dataFim,
                },
                titulos: { $ne: {} },
              },
            },
            // {
            //     $lookup: {
            //         from: 'erros',
            //         localField: 'contrato',
            //         foreignField: 'titulo.contrato',
            //         as: 'tit'
            //     }
            // },
            // {
            //     $match: {
            //         tit: { $size: 0 }
            //     }
            // }
          ],
        })
        .subscribe((res: any) => {
          resolve(res);
        });
    });
  }

  async getRecorrencia() {
    if (!environment.selected.cnpj) {
      return [];
    }
    const rangeDate = $('.dash-daterange').val().split('-');
    const dataIni = moment(rangeDate[0], 'DD/MM/YYYY').format('YYYY-MM-DD');
    const dataFim = moment(rangeDate[1], 'DD/MM/YYYY').add(1, 'day').format('YYYY-MM-DD');
    return new Promise(async resolve => {
      this.http
        .post(`${environment.cobranca}/find/${environment.selected.cnpj}/recorrencias`, {
          query: [
            {
              $match: {
                cnpj: environment.selected.cnpj,
                createdAt: {
                  $gt: dataIni,
                  $lt: dataFim,
                },
              },
            },
          ],
        })
        .subscribe((res: any) => {
          resolve(res);
        });
    });
  }

  async getSincronizados() {
    if (!environment.selected.cnpj) {
      return [];
    }
    const rangeDate = $('.dash-daterange').val().split('-');
    const dataIni = moment(rangeDate[0], 'DD/MM/YYYY').format('YYYY-MM-DD');
    const dataFim = moment(rangeDate[1], 'DD/MM/YYYY').add(1, 'day').format('YYYY-MM-DD');
    return new Promise(async resolve => {
      this.http
        .post(`${environment.cobranca}/find/${environment.selected.cnpj}/enviados`, {
          query: [
            {
              $match: {
                cnpj: environment.selected.cnpj,
                createdAt: {
                  $gt: dataIni,
                  $lt: dataFim,
                },
              },
            },
          ],
        })
        .subscribe((res: any) => {
          resolve(res);
        });
    });
  }

  async getRemarcados() {
    const rangeDate = $('.dash-daterange').val().split('-');
    const dataIni = moment(rangeDate[0], 'DD/MM/YYYY').format('YYYY-MM-DD');
    const dataFim = moment(rangeDate[1], 'DD/MM/YYYY').add(1, 'day').format('YYYY-MM-DD');
    return new Promise(async resolve => {
      this.http
        .post(`${environment.cobranca}/find/${environment.selected.cnpj}/remarcados`, {
          query: [
            {
              $match: {
                cnpj: environment.selected.cnpj,
                createdAt: {
                  $gt: dataIni,
                  $lt: dataFim,
                },
              },
            },
          ],
        })
        .subscribe((res: any) => {
          resolve(res);
        });
    });
  }

  async reenviaerro(e) {
    const load = await this.load.notifica({
      title: 'Movendo cobranças com erro..',
      date: moment().toISOString(),
      type: 'loading',
    });
    return new Promise(async resolve => {
      this.http.delete(`${environment.cobranca}/erro/${e}`).subscribe((res: any) => {
        load.dismiss();
        resolve(res);
      });
    });
  }

  async getVinculados(data) {
    const load = await this.load.notifica({
      title: 'Buscando Vinculados..',
      date: moment().toISOString(),
      type: 'loading',
    });

    if (!environment.selected.cnpj) {
      load.dismiss();
      return [];
    }

    return new Promise(async resolve => {
      const query: any = [
        {
          $match: {
            cnpj: environment.selected.cnpj,
            $or: [{ cliente: { $regex: data } }, { cpf: { $regex: data } }, { contrato: { $regex: data } }],
          },
        },
        {
          $lookup: {
            from: 'vinculados',
            localField: 'cpf',
            foreignField: 'cgc_cliente',
            as: 'vinculados',
          },
        },
      ];
      this.http
        .post(`${environment.cobranca}/find/${environment.selected.cnpj}/clientes`, {
          query,
        })
        .subscribe((res: any) => {
          load.dismiss();
          resolve(res);
        });
    });
  }

  async getCobrancas(q) {
    const load = await this.load.notifica({
      title: 'Filtrando..',
      date: moment().toISOString(),
      type: 'loading',
    });
    if (!environment.selected.cnpj) {
      load.dismiss();
      return [];
    }
    return new Promise(async resolve => {
      const date = $('.dash-daterange').val().split(' - ');
      const query: any = [
        {
          $match: {
            cnpj: environment.selected.cnpj,
            vencto: {
              $gte: moment(date[0], 'DD/MM/YYYY').format('YYYYMMDD'),
              $lte: moment(date[1], 'DD/MM/YYYY').format('YYYYMMDD'),
            },
          },
        },
        {
          $lookup: {
            from: 'vinculados',
            localField: 'cgc_cliente',
            foreignField: 'cgc_cliente',
            as: 'vinc',
          },
        },
        {
          $match: {
            vinc: {
              $size: 0,
            },
          },
        },
        {
          $group: {
            _id: {
              nome: '$nome',
              cgc_cliente: '$cgc_cliente',
              bairro: '$bairro',
              cep: '$cep',
              valor_titulo: '$valor_titulo',
              municipio: '$municipio',
            },
            vencto: { $min: '$vencto' },
          },
        },
        {
          $addFields: {
            '_id.vencto': '$vencto',
          },
        },
        {
          $replaceRoot: {
            newRoot: '$_id',
          },
        },
        {
          $sort: {
            bairro: 1,
            nome: 1,
          },
        },
        {
          $limit: 100,
        },
      ];

      if (q) {
        delete query[0].$match.vencto;
        if (q.$or.length > 0) {
          query[0].$match.$or = q.$or;
        }
        if (q.$and.length > 0) {
          query[0].$match.$and = q.$and;
        }
      }

      this.http
        .post(`${environment.cobranca}/find/${environment.selected.cnpj}/cobrancas`, {
          query,
        })
        .subscribe((res: any) => {
          load.dismiss();
          resolve(res);
        });
    });
  }

  async getcobrancasvinculados(q) {
    const load = await this.load.notifica({
      title: 'Filtrando vinculados..',
      date: moment().toISOString(),
      type: 'loading',
    });
    if (!environment.selected.cnpj) {
      return [];
    }
    return new Promise(async resolve => {
      const date = $('.dash-date').val();
      const query: any = [
        {
          $match: {
            cnpj: environment.selected.cnpj,
            cobrador: $('#cobrador').val(),
            dateTo: moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
          },
        },
        {
          $lookup: {
            from: 'cobrancas',
            localField: 'cgc_cliente',
            foreignField: 'cgc_cliente',
            as: 'cob',
          },
        },
        {
          $unwind: '$cob',
        },
        {
          $replaceRoot: {
            newRoot: '$cob',
          },
        },
        {
          $group: {
            _id: {
              nome: '$nome',
              cgc_cliente: '$cgc_cliente',
              bairro: '$bairro',
              cep: '$cep',
              valor_titulo: '$valor_titulo',
              municipio: '$municipio',
            },
            vencto: {
              $min: '$vencto',
            },
          },
        },
        {
          $addFields: {
            '_id.vencto': '$vencto',
          },
        },
        {
          $replaceRoot: {
            newRoot: '$_id',
          },
        },
        {
          $sort: {
            bairro: 1,
            nome: 1,
          },
        },
        {
          $limit: 100,
        },
      ];
      if (q) {
        delete query[0].$match.dateTo;
        if (q.$or.length > 0) {
          query[0].$match.$or = q.$or;
        }
        if (q.$and.length > 0) {
          query[0].$match.$and = q.$and;
        }
      }
      this.http
        .post(`${environment.cobranca}/find/${environment.selected.cnpj}/vinculados`, {
          query,
        })
        .subscribe((res: any) => {
          load.dismiss();
          resolve(res);
        });
    });
  }

  async getErros() {
    if (!environment.selected.cnpj) {
      return [];
    }
    const rangeDate = $('.dash-daterange').val().split('-');
    const dataIni = moment(rangeDate[0], 'DD/MM/YYYY').format('YYYY-MM-DD');
    const dataFim = moment(rangeDate[1], 'DD/MM/YYYY').add(1, 'day').format('YYYY-MM-DD');
    return new Promise(async resolve => {
      this.http
        .post(`${environment.cobranca}/find/${environment.selected.cnpj}/erros`, {
          query: [
            {
              $match: {
                cnpj: environment.selected.cnpj,
                createdAt: {
                  $gt: dataIni,
                  $lt: dataFim,
                },
              },
            },
          ],
        })
        .subscribe((res: any) => {
          resolve(res);
        });
    });
  }

  async baixacobrancasProtheus(body) {
    return new Promise(resolve => {
      this.http.put(`${environment.cobranca}/baixa/${environment.selected.cnpj}`, body).subscribe((res: any) => {
        resolve(res);
      });
    });
  }

  baixacobrancasVirtus(titulo: any) {
    if (!environment.selected.cnpj) {
      return [];
    }
    return new Promise(resolve => {
      this.http
        .post(`${environment.cobranca}/baixavirtus`, {
          titulo,
          cnpj: environment.selected.cnpj,
        })
        .subscribe((res: any) => {
          resolve(res);
        });
    });
  }

  async reagendamentoProtheus(body) {
    if (!environment.selected.cnpj) {
      return [];
    }
    return new Promise(resolve => {
      this.http.put(`${environment.cobranca}/baixa/${environment.selected.cnpj}`, body).subscribe((res: any) => {
        resolve(res);
      });
    });
  }

  async senderro(titulo: any, error: string) {
    if (!environment.selected.cnpj) {
      return [];
    }
    return new Promise(resolve => {
      this.http
        .post(`${environment.cobranca}/erro`, {
          titulo,
          erro: error,
          cnpj: environment.selected.cnpj,
        })
        .subscribe((res: any) => {
          resolve(res);
        });
    });
  }

  async sendRemarcados(remarcados) {
    if (!environment.selected.cnpj) {
      return [];
    }
    return new Promise(async resolve => {
      this.http.put(`${environment.cobranca}/vincula/${environment.selected.cnpj}`, { remarcados }).subscribe(
        (res: any) => {
          resolve(res);
        },
        error => {
          resolve(error.error);
        }
      );
    });
  }

  async vincular(t, date, cobrador) {
    const load = await this.load.notifica({
      title: 'Vinculando..',
      date: moment().toISOString(),
      type: 'loading',
    });
    if (!environment.selected.cnpj) {
      load.dismiss();
      return [];
    }
    return new Promise(resolve => {
      if (!environment.selected.cnpj) {
        load.dismiss();
        return this.load.notifica({
          title: 'Erro!',
          date: moment().toDate(),
          type: 'error',
        });
      }
      this.http
        .post(`${environment.cobranca}/vincula`, {
          cpf: t.cgc_cliente,
          dateTo: date,
          cnpj: environment.selected.cnpj,
          uid: cobrador,
        })
        .subscribe((res: any) => {
          load.dismiss();
          resolve(res);
        });
    });
  }

  async desvincular(t) {
    const load = await this.load.notifica({
      title: 'Desvinculando..',
      date: moment().toISOString(),
      type: 'loading',
    });
    if (!environment.selected.cnpj) {
      load.dismiss();
      return [];
    }
    return new Promise(resolve => {
      this.http
        .put(`${environment.cobranca}/desvincula`, {
          cpf: t.cgc_cliente,
        })
        .subscribe((res: any) => {
          load.dismiss();
          resolve(res);
        });
    });
  }

  async getcobradores() {
    if (environment.selected && environment.selected.cnpj) {
      return new Promise(resolve => {
        this.http.get(`${environment.sso}/cobradores-novo/${environment.selected.cnpj}`).subscribe((res: any) => {
          resolve(res);
        });
      });
    }
    return [];
  }

  async consulta(col, query) {
    if (environment.selected && environment.selected.cnpj) {
      return new Promise(resolve => {
        this.http
          .post(`${environment.cobranca}/find/${environment.selected.cnpj}/${col}`, {
            query: query
              ? query
              : [
                  {
                    $match: {
                      cnpj: environment.selected.cnpj,
                    },
                  },
                  {
                    $limit: 10,
                  },
                ],
          })
          .subscribe((res: any) => {
            resolve(res);
          });
      });
    }
    return [];
  }

  atualizacliente(cpf: any) {
    if (!environment.selected.cnpj) {
      return [];
    }
    return new Promise(async resolve => {
      this.http.get(`${environment.cobranca}/sync/cliente/${environment.selected.cnpj}/${cpf}`).subscribe(
        (res: any) => {
          resolve(res);
        },
        error => {
          resolve({
            error: true,
            msg: error.error.error,
            cgc: cpf,
          });
        }
      );
    });
  }
}
